module.exports = new __parcel__URL__("TooManyFilters.268c3f7b.svg").toString();